module.exports = __webpack_public_path__ + "img/logomark-pink.127c0916.svg";